import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  return <nav className={`fixed top-0 w-full z-50 transition-all duration-500 backdrop-blur-sm ${scrolled ? 'bg-white/95 shadow-lg py-2' : 'bg-transparent py-4'}`} data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="flex justify-between items-center" data-id="element-206">
          <div className="flex items-center" data-id="element-207">
            <div className="flex-shrink-0 flex items-center" data-id="element-208">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gYt3ksEJhJywGjv4NxKduQ/image.png" alt="Otterreach logo" className="h-10 w-auto mr-2 transition-transform duration-300 hover:scale-105" data-id="element-209" />
              <span className={`font-bold text-2xl ${scrolled ? 'text-gradient-primary' : 'text-white'}`} style={{
              background: scrolled ? 'linear-gradient(to right, #e8c77a, #e57373)' : '',
              WebkitBackgroundClip: scrolled ? 'text' : '',
              WebkitTextFillColor: scrolled ? 'transparent' : ''
            }} data-id="element-210">
                Otterreach
              </span>
            </div>
          </div>
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-8" data-id="element-211">
            {['Services', 'About', 'Process', 'Testimonials'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className={`px-3 py-2 font-medium hover:text-amber-400 relative group transition-colors ${scrolled ? 'text-gray-700' : 'text-white'}`} data-id="element-212">
                {item}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-amber-400 to-red-400 group-hover:w-full transition-all duration-300" data-id="element-213"></span>
              </a>)}
            <a href="#contact" className="relative px-5 py-2.5 rounded-md font-medium transition-all duration-300 bg-gradient-to-r from-amber-400 to-red-400 hover:shadow-lg hover:shadow-amber-400/20 text-white overflow-hidden group" data-id="element-214">
              <span className="relative z-10" data-id="element-215">Get Started</span>
              <span className="absolute inset-0 bg-gradient-to-r from-amber-500 to-red-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-216"></span>
            </a>
          </div>
          <div className="flex items-center md:hidden" data-id="element-217">
            <button onClick={() => setIsOpen(!isOpen)} className={`inline-flex items-center justify-center p-2 rounded-md focus:outline-none transition-colors ${scrolled ? 'text-gray-700 hover:text-amber-500' : 'text-white hover:text-amber-200'}`} aria-expanded="false" data-id="element-218">
              <span className="sr-only" data-id="element-219">Open main menu</span>
              {isOpen ? <XIcon className="block h-6 w-6" data-id="element-220" /> : <MenuIcon className="block h-6 w-6" data-id="element-221" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white/95 backdrop-blur-sm shadow-lg absolute w-full animate-fadeIn" data-id="element-222">
          <div className="pt-2 pb-3 space-y-1 px-4" data-id="element-223">
            {['Services', 'About', 'Process', 'Testimonials'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-amber-500 hover:bg-amber-50/50 rounded-md transition-colors" onClick={() => setIsOpen(false)} data-id="element-224">
                {item}
              </a>)}
            <a href="#contact" className="block px-3 py-3 text-base font-medium bg-gradient-to-r from-amber-400 to-red-400 text-white hover:from-amber-500 hover:to-red-500 rounded-md mt-3 text-center transition-colors" onClick={() => setIsOpen(false)} data-id="element-225">
              Get Started
            </a>
          </div>
        </div>}
    </nav>;
}